<script setup>
import {computed, onMounted, ref, watch} from "vue";
import dashboardService from "@/services/ecosystem/dashboard.service";
import AddStartups from "@/components/startups/import/AddStartups.vue";
import CompanyProfile from "@/components/CompanyProfile.vue";
import {useStore} from "vue2-helpers/vuex";
import {validUrl} from "@/helpers/string";
import profileService from "@/services/ecosystem/profile.service";

const emit = defineEmits(['completed'])
const store = useStore()

const step = ref(1);
const hasPortfolio = ref(false);
const show = ref(false);
const addStartups = ref(null);
const companyProfile = ref(null);
const startupsAdded = ref(false);
const portfolioUrl = ref('');

const portfolioAdded = computed(() => validUrl(portfolioUrl.value));

watch(step, value => {
    if (value === 2 && hasPortfolio.value) {
        step.value = 3;
        return;
    }

    if (value > 2) {
        show.value = false;
        emit('completed');

        if (store.state.user.show_company_profile_form) {
            companyProfile.value.open();
        }
    }

    saveStep();
});

onMounted(() => {
    if (store.state.user.onboarding_step < 3) {
        getLastStep();
    }
});

async function getLastStep() {
    const {data} = await dashboardService.getOnboardingStep();

    step.value = (data.step && data.step > 0) ? data.step : 1;
    hasPortfolio.value = data.has_portfolio;

    if (step.value <= 2) {
        show.value = true;
    }
}

async function saveStep() {
    await dashboardService.saveOnboardingStep(step.value);
}

async function finish() {
    if (portfolioUrl.value) {
        await profileService.savePortfolioUrl(portfolioUrl.value);
    }

    step.value++;
}
</script>

<template>
    <div
        v-if="show"
        id="needs-onboarding"
        class="needs-onboarding"
    >
        <div class="needs-onboarding__inner">
            <div v-if="step === 1">
                <h2 class="heading2">Welcome to SwitchPitch</h2>

                <p class="needs-onboarding__text">View enterprise needs and submit your portfolio startups</p>

                <div class="btn-xl-wrapper">
                    <a @click="step++" class="btn btn-xl btn-xl-next">
                        Get Started
                    </a>
                </div>
            </div>

            <div v-else-if="step === 2">
                <h2 class="heading2">Add Your Startups</h2>

                <form class="form-v2 pb-5">
                    <div class="form-v2__item">
                        <label>Add Via Protfolio URL:</label>
                        <input type="text" v-model="portfolioUrl" />
                    </div>

                    <div class="form-v2__item">
                        <label>Or upload a CSV:</label>

                        <div class="input-file-v2">
                            <label @click="addStartups?.open()">Upload CSV</label>
                        </div>
                    </div>
                </form>

                <div class="btn-xl-wrapper">
                    <button :disabled="!(startupsAdded || portfolioAdded)" @click="finish" class="btn btn-xl btn-xl-next">
                        Save & Finish Setup
                    </button>
                </div>

                <div class="mt-3">
                    <a class="link" @click="step++">Skip For Now</a>
                </div>
            </div>
        </div>

        <CompanyProfile ref="companyProfile"/>

        <AddStartups
            ref="addStartups"
            only-multiple
            @startupsAdded="startupsAdded = true"
        />
    </div>
</template>

<style scoped>
</style>
